import axios from 'axios'
import {
  DeliverynoteDraftInterface,
  DeliverynoteInterface,
} from 'client/components/DocumentsV1/Deliverynote/DeliverynoteInterface'

import { DocumentTypes } from '../Interfaces/Draft/DraftInterface'
import { getDocumentV1 } from './document'
import { getRequestConfig } from './index'

export async function saveDeliverynote(deliveryNote: DeliverynoteDraftInterface): Promise<DeliverynoteDraftInterface> {
  const url = `/rest-invoice/api/v1/deliverynotes/${deliveryNote.id}`
  delete deliveryNote.id
  const response = await axios.put<DeliverynoteDraftInterface>(url, deliveryNote, getRequestConfig())
  return response.data
}

export async function getDeliverynote(id: number): Promise<DeliverynoteInterface> {
  return getDocumentV1(DocumentTypes.DELIVERYNOTE, id)
}
